import React, { useState } from 'react';
import { useWizard, WizardStepLayout } from 'components/layout/wizards';
import { SelectField, BaseTextArea, InputLabel } from 'components/forms';
import { Button, PrimaryButton } from 'components/buttons';
import {
  WORKER_ACTION_TYPES,
  WORKER_ACTION_TYPES_OPTIONS
} from 'constants/workers';

export function ValidationLogicForm({
  initialValues = {},
  onSubmit,
  onCancel,
  isWizard = false,
  saving = false
}) {
  const [onSuccess, setOnSuccess] = useState(initialValues.onSuccess || WORKER_ACTION_TYPES.SEND);
  const [onSuccessMessage, setOnSuccessMessage] = useState(initialValues.onSuccessMessage || '');
  const [onFailure, setOnFailure] = useState(initialValues.onFailure || WORKER_ACTION_TYPES.SEND);
  const [onFailureMessage, setOnFailureMessage] = useState(initialValues.onFailureMessage || '');

  const handleProceed = () => {
    onSubmit({
      onSuccess,
      onSuccessMessage: onSuccess === WORKER_ACTION_TYPES.UPDATE_MESSAGE ? onSuccessMessage : null,
      onFailure,
      onFailureMessage: onFailure === WORKER_ACTION_TYPES.UPDATE_MESSAGE ? onFailureMessage : null
    });
  };

  const formContent = (
    <div className="space-y-8">
      <div className="space-y-4">
        <h3 className="text-md font-medium text-white">On Success (Match Found)</h3>
        <SelectField
          label="Action"
          value={onSuccess}
          onChange={setOnSuccess}
          options={WORKER_ACTION_TYPES_OPTIONS}
        />
        {onSuccess === WORKER_ACTION_TYPES.UPDATE_MESSAGE && (
          <div>
            <InputLabel htmlFor="successMessage">Custom Message</InputLabel>
            <div className="mt-2">
              <BaseTextArea
                id="successMessage"
                value={onSuccessMessage}
                onChange={(e) => setOnSuccessMessage(e.target.value)}
                placeholder="Worker found a match!"
              />
            </div>
          </div>
        )}
      </div>

      <div className="space-y-4">
        <h3 className="text-md font-medium text-white">On Failure (No Match / Error)</h3>
        <SelectField
          label="Action"
          value={onFailure}
          onChange={setOnFailure}
          options={WORKER_ACTION_TYPES_OPTIONS}
        />
        {onFailure === WORKER_ACTION_TYPES.UPDATE_MESSAGE && (
          <div>
            <InputLabel htmlFor="failureMessage">Custom Message</InputLabel>
            <div className="mt-2">
              <BaseTextArea
                id="failureMessage"
                value={onFailureMessage}
                onChange={(e) => setOnFailureMessage(e.target.value)}
                placeholder="Worker failed to find a match."
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );

  if (isWizard) {
    return (
      <WizardStepLayout
        title="Validation Logic"
        description="Decide what happens based on the validation result."
        primaryAction={{
          label: 'Next',
          onClick: handleProceed
        }}
      >
        {formContent}
      </WizardStepLayout>
    );
  }

  return (
    <div>
      {formContent}
      <div className="flex justify-end gap-3 mt-6 pt-4 border-t border-gray-700 relative z-20">
        <Button onClick={onCancel}>Cancel</Button>
        <PrimaryButton onClick={handleProceed} saving={saving}>
          Save Changes
        </PrimaryButton>
      </div>
    </div>
  );
}

export default function ValidationLogicStep() {
  const { nextStep, data } = useWizard();

  return (
    <ValidationLogicForm
      initialValues={{
        onSuccess: data.onSuccess,
        onSuccessMessage: data.onSuccessMessage,
        onFailure: data.onFailure,
        onFailureMessage: data.onFailureMessage
      }}
      onSubmit={(values) => nextStep(values)}
      isWizard
    />
  );
}
